<template>
  <el-table
    ref="table"
    stripe
    :data="data"
    :default-sort="defaultSort"
    @sort-change="$emit('sort-change', $event)"
    @selection-change="$emit('selection-change', $event)"
    @select="changeSelectAll"
    @select-all="changeSelectAll"
  >
    <template #empty>
      <span v-html="defaultEmptyText"></span>
    </template>
    <el-table-column type="selection" width="50" align="center" />
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column prop="ad_id" sortable="custom" fixed>
      <template #default="{ row }">{{ row.adId }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipAdId')" placement="top">
          <span>{{ $t('c.table.columnNameAdId') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ad" fixed>
      <template #default="{ row }">{{ row.ad }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipAd')" placement="top">
          <span>{{ $t('c.table.columnNameAd') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column prop="headline_1">
      <template #default="{ row }">{{ row.headline_1 }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipFirstAdHeadline')" placement="top">
          <span>{{ $t('c.table.columnNameFirstAdHeadline') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column prop="headline_2">
      <template #default="{ row }">{{ row.headline_2 }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipSecondAdHeadline')" placement="top">
          <span>{{ $t('c.table.columnNameSecondAdHeadline') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="campaign">
      <template #default="{ row }">{{ row.campaign }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCampaign')" placement="top">
          <span>{{ $t('c.table.columnNameCampaign') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column prop="ad_group" sortable="custom">
      <template #default="{ row }">{{ row.adGroup }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipAdGroup')" placement="top">
          <span>{{ $t('c.table.columnNameAdGroup') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="impressions" sortable="custom">
      <template #default="{ row }">{{ row.impressions }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipAdsImpressions')" placement="top">
          <span>{{ $t('c.table.columnNameImpressions') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ctr" sortable="custom">
      <template #default="{ row }">
        <span :class="{ 'text-red': checkReasonForCTRQuality(row.qualityReason) }">
          {{ row.ctr }}
        </span>
      </template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCTR')" placement="top">
          <span>{{ $t('c.table.columnNameCTR') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="clicks" sortable="custom">
      <template #default="{ row }">{{ row.clicks }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipAdClicks')" placement="top">
          <span>{{ $t('c.table.columnNameClicks') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cpc" sortable="custom">
      <template #default="{ row }">{{ row.cpc }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCPC')" placement="top">
          <span>{{ $t('c.table.columnNameCPC') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column prop="conv_rate" sortable="custom">
      <template #default="{ row }">{{ row.convRate | toFixed(1) }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCR')" placement="top">
          <span>{{ $t('c.table.columnNameCR') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="conversions" sortable="custom">
      <template #default="{ row }">{{ row.conversions }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipConversions')" placement="top">
          <span>{{ $t('c.table.columnNameConversions') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cost" sortable="custom">
      <template #default="{ row }">{{ row.cost }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCost')" placement="top">
          <span>{{ $t('c.table.columnNameCost') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column prop="cost_conv" sortable="custom">
      <template #default="{ row }">
        <span :class="{ 'text-red': checkReasonForCPLQuality(row.qualityReason) }">
          {{ row.costConv }}
        </span>
      </template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCPL')" placement="top">
          <span>{{ $t('c.table.columnNameCPL') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('c.table.columnNameDisablingPeriod')"
      prop="during"
      sortable="custom"
    >
      <template #default="{ row }">{{ getHumanReadablePeriod(row.during) }}</template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column
      :label="$t('c.table.columnNameDisablingDate')"
      prop="created_at"
      sortable="custom"
    >
      <template #default="{ row }">{{ row.createdAt | formatDate }}</template>
    </el-table-column>
    <!-- TODO: привести к общему виду параметр 'prop' всех таблиц (для сортировки) -->
    <el-table-column
      :label="$t('c.table.columnNameReason')"
      prop="quality_reason"
      sortable="custom"
    >
      <template #default="{ row }">
        <span :class="{ 'text-red': checkReasonForBanReasonQuality(row.qualityReason) }">
          {{ getHumanReadableReason(row.qualityReason) }}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tableMixin from '@/mixins/table'
import formatFiltersMixin from '@/mixins/formatFilters'
import tableFormatMixin from '@/mixins/tableFormat'
import tableBanReasonMixin from '@/mixins/tableBanReason'

export default {
  name: 'VActionLogAdsTable',

  mixins: [tableMixin, formatFiltersMixin, tableFormatMixin, tableBanReasonMixin],

  props: {
    data: {
      type: Array,
      required: true
    },
    defaultSort: {
      type: Object,
      required: true,
      validator(defaultSort) {
        const props = ['prop', 'order']
        const sortProps = Object.getOwnPropertyNames(defaultSort)

        return props.every(prop => sortProps.includes(prop))
      }
    }
  }
}
</script>
